import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Pagination, { PaginationPresentationProps } from "@theStellarBlueprint/Components/CustomCuttingToolPagination";
import CustomApplicationState from "@theStellarBlueprint/Store/CustomApplicationState";
import { getCuttingToolConfigState } from "@theStellarBlueprint/Store/Data/CuttingToolConfig/CuttingToolConfigSelector";
import { getCuttingToolPaginationDataByCategoryId } from "@theStellarBlueprint/Store/Data/CuttingToolPagination/CuttingToolPaginationSelector";
import CuttingToolPageSizeHandler from "@theStellarBlueprint/Store/Data/CuttingToolPagination/Handlers/CuttingToolPageSize";
import CuttingToolPaginationHandler from "@theStellarBlueprint/Store/Data/CuttingToolPagination/Handlers/CuttingToolPagination";
import React, { FC,useEffect,useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";



const mapStateToProps = (state: CustomApplicationState) => {
    const attributes = getCuttingToolConfigState(state);
    const productPaginationData = getCuttingToolPaginationDataByCategoryId(state);
    const defaultPageNumber = state?.StellarState?.CuttingToolPagination?.cuttingToolPageNumber;
    const defaultPageSize= state?.StellarState?.CuttingToolPagination?.cuttingToolPageSize;
    const productsByCategory = getProductsDataView(state, {
        categoryId: state?.StellarState?.CuttingToolCategoryId?.categoryId,
        applyPersonalization: true,
        expand: ["attributes", "facets"],
        includeAttributes: ["includeOnProduct"],
        includeSuggestions: true,
        sort: "1",
        page: state?.StellarState?.CuttingToolPagination?.cuttingToolPageNumber,
        pageSize:state?.StellarState?.CuttingToolPagination?.cuttingToolPageSize,
        attributeValueIds: attributes.attributeValueIds,
    });

    return {
        productPaginationData,
        defaultPageNumber,
        products:productsByCategory,
        defaultPageSize
    }
};

const mapDispatchToProps = {
    CuttingToolPaginationHandler,
    CuttingToolPageSizeHandler
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface CuttingToolPaginationStyles {
    pagination?: PaginationPresentationProps;
    perPageSelect?: SelectPresentationProps;
    pageSelect?: SelectPresentationProps;
    pageLinkList?: InjectableCss;
    pageLinkListWrapper?: InjectableCss;
    mobileNavContainer?: InjectableCss;
}

export const paginationStyles: CuttingToolPaginationStyles = {
    pagination: {
        cssOverrides: {
            pagination: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                > nav {
                                    width:84%;
                                    -webkit-box-pack: end;
                                    justify-content: flex-end;
                                }
                                [data-test-selector="pagination_firstButton"]{
                                    width: 15px;
                                }
                            `,
                            null,
                            null,
                        ],
                        "max",
                    )}
            `,
            perPageSelect: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                        width:16%;
                        div > label {
                            width: 100px;
                         margin-right: 8px;
                        padding: 9px 0px 0 0;
                        },
                        div > div > select[data-test-selector="pagination_resultsPerPage"] {
                            width: 50px;
                            padding-right: 0px !important;
                        },
                        div[class^="FormFieldStyle"] > div[class^="FormInputWrapper"] > span {
                            right: 0px !important;
                            left: 16px;
                        }
                    `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
            linkList: css`
            ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                   null,
                    null,
                    css`
                    ul li {
                        button {
                            max-width: 30px;
                            padding: 0px;
                        }
                    }
                    `,
                    null,
                    null,
                ],
                "max",
            )}
                ul li {
                    button {
                        span {
                            color: rgb(0, 0, 0) !important;
                        }
                    }
                    button[aria-current="page"] {
                        cursor: default;
                        border: 1px solid rgb(0, 0, 255) !important;
                        background: #ffffff !important;
                        span {
                            color: rgb(1, 30, 251) !important;
                        }
                    }
                }
            `,
        },
    },
};

const styles = paginationStyles;

const CuttingToolPagination: FC<Props> = ({
    CuttingToolPaginationHandler,
    productPaginationData,
    CuttingToolPageSizeHandler,
    defaultPageNumber,
    products,
    defaultPageSize
}) => {
    
    const productDataPagination = productPaginationData?productPaginationData.pagination:null
    const totalItemCount=products?((products as unknown) as ProductsDataView)?.pagination?.totalItemCount:null;
    const [currentPage, setCurentPage] = useState<number>(defaultPageNumber);
    const [currentPageSize, setCurentPageSize] = useState<number>(defaultPageSize);
    const attributeFacets = products.value && products["attributeTypeFacets"];

    useEffect(() => {
        setCurentPage(defaultPageNumber);
        setCurentPageSize(defaultPageSize);
    }, [defaultPageNumber,productDataPagination,defaultPageSize]);
    

    const changePage = (newPageIndex: number) => {
        setCurentPage(newPageIndex)
        CuttingToolPaginationHandler({
            cuttingToolPageNumber: newPageIndex,
        })
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = Number(event.currentTarget.value);
        setCurentPageSize(newPageSize);
        CuttingToolPageSizeHandler({
            cuttingToolPageSize:newPageSize
        })
        
        CuttingToolPaginationHandler({
            cuttingToolPageNumber: 1,
        })
        setCurentPage(1)
    };
if(productPaginationData && productDataPagination && attributeFacets){
    return (
        <Pagination
            {...styles.pagination}
            resultsCount={totalItemCount as number}
            currentPage={currentPage}
            resultsPerPage={currentPageSize}
            resultsPerPageOptions={productDataPagination.pageSizeOptions}
            resultsPerPageLabel="show"
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            pageSizeCookie="CuttingToolPage-PageSize"
        />
    );
}
    return null

   
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CuttingToolPagination),
    definition: {
        group: "Basic",
        displayName: "Cutting Tool Pagination",
        fieldDefinitions: [

        ],
    },
};

export default widgetModule;
